import "./Tbl.css";

// import IconPencil from "../../assets/images/pencil.svg";
// import IconX from "../../assets/images/x.svg";
// import IconCards from "../../assets/images/grid.svg";
// import IconPanels from "../../assets/images/hdd-stack.svg";
// import IconTable  from "../../assets/images/table.svg";
// import IconList  from "../../assets/images/justify.svg";
// import IconTree  from "../../assets/images/bar-chart-steps.svg";

import { useState, useLayoutEffect, useRef, useEffect } from "react";

import Tree from "../../components/Tree/Tree.jsx";
import { useParams, useNavigate } from "react-router-dom";

import { useRcds, regUses, randomUUID, useTblDef, useOrdersOfStatus, getStringHash, delTblRcds} from "../../axios_with_token.js";

import { useRcdEditDialog } from "../Dialog/Dialog.jsx";

import WWTabs from "../../components/WWTabs/WWTabs.jsx";
import { useForm } from "react-hook-form";
import getWidget from "../../widgets/widgets.js";

export const CompListTypes = {
    list: RcdList,
    tree: Tree,
    cards: RcdCards
};

function usePagination(page, rcdsPerPage, setPage){
    // const [_page, setPage] = useState(page || 0);
    // const [rcdsPerPage, setRcdsPerPage] = useState(rcdsPerPage || 10);

    return {
        page,
        setPage,
        rcdsPerPage,
        // setRcdsPerPage,
        Pagination: ({rcdCount})=>{
            return <ul style={{padding: '0'}}>
                <span> ( {rcdCount} records, {rcdsPerPage} / page ) </span> 
                {Array(Math.ceil((rcdCount||1)/(rcdsPerPage||1))).fill(undefined).map((_,idx)=>{
                    return <li key={idx}
                        style={{display: "inline-block", marginRight:"1em", cursor:"pointer", color:(idx==page)?"red":"auto"}}
                        onClick={evt=>{
                            setPage(idx);
                        }}
                    >{idx+1}</li>;
                })}
            </ul>;
        }
    };
}

export function SelectListType({onSelect}){
    return <div>
        {Object.keys(CompListTypes).map(listType=><button
            key={listType}
            type="button"
            className="btn btn-sm btn-primary mx-1"
            onClick={evt=>onSelect(listType)}
        >{listType}</button>)}
    </div>;
}

// [] delayed setParam using callback
function ApplyUseParams({setTblName, tblName:tblNameIn}){
    const params = useParams() || {};
    const tblName = params['tblName'];
    useEffect(_=>{
        setTimeout(_=>setTblName(tblName || 'poses'), 1);
    });
    // setTblName(setTblName);
    return;
}

export default function Tbl({
    tblName:tblNameIn,
    page, rcdsPerPage, filter,
    showIndex, 
    hideListTypeSelector,
    hideListFldsSelector,
    hideTitle,
    hideNewBtn,
    useParams,
    listFlds:listFldsIn,
    btns:btnsIn
}){
    // [!!!important] call useParams in component will cause refresh of the componennt in chrome, not in ff
    // const params = useParams() || {};
    // tblName = tblName || params['tblName'];
    // [---!!!]
    const [tblNameParam, setTblNameParam] = useState(tblNameIn);
    function setTblNameParamWhenChanged(name){
        if(tblNameParam != name){
            setTblNameParam(name);
        }
    }
    const [updateId, setUpdateId] = useState(0);
    const forceUpdate = _=>{
        setUpdateId(prevUpdateId => prevUpdateId + 1);
    }

    const tblName = tblNameParam;

    const {regUse, DefaultResponse} = regUses();

    const fnContainer = {};
    const {
        // formId: editRcdFormId,
        isDialogOpen,
        setIsDialogOpen,
        openDialog,
        closeDialog,
        handleConfirm,

        setTblName,
        setRcdId,
        setRcdDefault,
        getRcdDefault,

        invalidate:invalidateRcd,

        Dialog: EditDialog,
        
    } = regUse(useRcdEditDialog({
        tblName,
        rcdId:null,
        reset:[updateId],
        onSaved: _=>{
            // fnContainer.invalidateList&&fnContainer.invalidateList();
            // fnContainer.invalidateRcd&&fnContainer.invalidateRcd();
            forceUpdate();
        }
    }));

    fnContainer.invalidateRcd = invalidateRcd;
    const {
        Component:TblList,
        loading:TblListLoading,
        error:TblListError,
        invalidate:invalidateList,
        setActiveRcdId,
        setListType
    } = regUse(useRcdList({
        // listType,
        tblName,
        page,
        rcdsPerPage,
        filter,
        searchFlds:listFldsIn,
        listFlds:listFldsIn,
        showIndex,
        hideListTypeSelector,
        hideListFldsSelector,
        reset:[updateId],
        btns:btnsIn||{
            edit: 'stdEdit',
            addChild: 'stdAddChild',
            delete: 'stdDelete'
        },
        editDlg:{setTblName, setRcdId, openDialog, getRcdDefault, setRcdDefault},
        _btns:{
            edit: ({rcdId, setRcdActive})=><button type="button"
                className="btn btn-sm btn-primary"
                onClick={evt=>{
                    // evt.stopPropagation();
                    setTblName(tblName);
                    // [] for RcdEditDialog
                    setRcdId(rcdId);
                    // [] for list
                    setRcdActive&&setRcdActive();
                    openDialog();
                }}
            >edit</button>,
            addChild: ({rcdId, setRcdActive, listType})=>(listType=="Tree")&&<button type="button"
                className="btn btn-sm btn-primary"
                onClick={evt=>{
                    // evt.stopPropagation();
                    setTblName(tblName);
                    // [] for RcdEditDialog
                    // getNewRcdId()
                    setRcdId(false);
                    console.log('rcd default:', {...getRcdDefault(), pid:rcdId});
                    setRcdDefault({...getRcdDefault(), __pid:rcdId})

                    // [] for list
                    setRcdActive&&setRcdActive();
                    openDialog();
                }}
            >add child</button>,
            delete: ({rcdId, setRcdActive})=><button type="button"
                className="btn btn-sm btn-warning"
                onClick={evt=>{
                    // evt.stopPropagation();
                    setTblName(tblName);
                    // [] for RcdEditDialog
                    setRcdId(rcdId);
                    setTimeout(_=>{
                        if(window.confirm('sure to delete?')){
                            delTblRcds(tblName, rcdId).then(r=>{
                                invalidateList();
                            })
                        }
                        setRcdActive&&setRcdActive();
                    }, 10)
                    setRcdActive&&setRcdActive();

                }}
            >delete</button>
    }}));
    fnContainer.invalidateList = invalidateList;

    return <DefaultResponse>
       {useParams&&<ApplyUseParams
            setTblName={setTblNameParamWhenChanged}
        ></ApplyUseParams>}
        {/* new button */}
        {!hideTitle&&<h3>tbl: [ {tblName} ] 
            {!hideNewBtn&&<button
                className="btn btn-primary mx-3"
                onClick={evt=>{
                    // [] for RcdEditDialog
                    setTblName(tblName);
                    setRcdId(false);
                    // [] for list
                    setActiveRcdId&&setActiveRcdId(0);
                    openDialog();
                }}
            >new</button>}
        </h3>}

        <EditDialog></EditDialog>
        
        <TblList></TblList>
    </DefaultResponse>

}

export function RcdCards({tblDef:tblDefIn, rcds:rcdsIn, opts, activeRcdId, setActiveRcdId, listFlds:listFldsIn, highLightFn}){

    // if(!tblDef)return<div>[RcdList] tblDef null. </div>;
    const tblDef = tblDefIn || {};

    const rcds = (rcdsIn||{}).rcds || [];

    opts = opts || {};
    const listFlds = (listFldsIn || ((opts.listFlds&&opts.listFlds) || (tblDef.listFlds?tblDef.listFlds:Object.keys(tblDef.inputSettings).join(',')))).split(','); //['__id']
    
    return <div>
        {(rcds).map(rcd=><span
            key={rcd.__id}
            __id={rcd.__id}
            className={`${(activeRcdId==rcd.__id)?'border border-warning':''} ${(highLightFn&&highLightFn(rcd))?'bg-warning':'bg-primary'} ww-rcd-card-item badge rounded-pill  m-1`}
            // [] moved to parent
            // onClick={evt=>{
            //     console.log('onItemClick:', rcd.__id, opts);
            //     setActiveRcdId(rcd.__id);
            //     opts.onItemClick && opts.onItemClick({rcdId: rcd.__id, evt});
            // }}
        >{((opts||{}).cardShowFlds||'__id').split(',').map(fldName=>rcd[fldName]).join(' / ')}</span>)}
    </div>;
}

export function RcdList({tblDef:tblDefIn, rcds:rcdsIn, opts, activeRcdId, setActiveRcdId, listFlds:listFldsIn, hideIndex, hideID}){
    // if(!tblDef)return<div>[RcdList] tblDef null. </div>;
    const tblDef = tblDefIn || {};
    const rcds = rcdsIn || {
        rcds: []
    };

    opts = opts || {};
    const listFlds = (_listFlds=>{
        if(!_listFlds)return ['__id'];
        if(_listFlds.constructor == String)return _listFlds.split(',');
        if(!_listFlds.constructor == Array)return ['__id'];
        return _listFlds;
    })(listFldsIn || ((opts.listFlds&&opts.listFlds) || (tblDef.listFlds?tblDef.listFlds:Object.keys(tblDef.inputSettings||{}).join(',')))); //['__id']

    return <table className="table rcd-list table-hover" style={{maxWidth: "100%"}}>
        <thead>
            <tr>
                {!hideIndex&&<th>No.</th>}
                {!hideID&&<th>__id</th>}
                {/* [] btns to control whole list */}
                {/* {JSON.stringify(rcds||[])}  */}
                <th>{opts.listBtns?Object.keys(opts.listBtns||{}).map(btnId=>{
                            const Wgt = opts.listBtns[btnId];
                            return <Wgt
                                key={Math.random()}
                            ></Wgt>
                        }):"action"}
                </th>
                { listFlds.map((fldName, fldIdx)=>{
                    return <th key={Math.random()}>
                        {fldName}
                    </th>;
                })}

            </tr>
        </thead>
        <tbody>
            {(rcds.rcds?(rcds.rcds.constructor===Array?rcds.rcds:[]):[]).map((rcd, rcdIdx)=>{
                return <tr key={Math.random()} className={(activeRcdId&&(activeRcdId == rcd.__id)?"active":"")} style={{verticalAlign:"middle"}}>
                    {!hideIndex&&<td key="__idx" style={{width: '0'}}>{(opts.page||0)*(opts.rcdsPerPage||0)+rcdIdx+1}</td>}
                    {!hideID&&<td key="____id" style={{width: '0'}}>id-{rcd.__id||''}</td>}
                    <td
                        style={{
                            // width: 'auto',
                            // 'white-space': "nowrap",
                            // wordWrap: "inherit"
                            // // padding: "8px"
                            // display: 'flex'
                        }}
                        // className="input-group"
                    >
                        <div
                            style={{
                                // width: 'auto',
                                // 'white-space': "nowrap",
                                // wordWrap: "inherit"
                                // // padding: "8px"
                                display: 'flex'
                            }}
                        
                            // className="input-group"
                        >
                            {/* [] btns to control single rcd */}
                            {(opts.btns?(opts.btns.constructor===Array?opts.btns:[]):[]).map((Wgt, wgtIdx)=>{
                                if(Wgt.generator){
                                    Wgt = Wgt.generator({
                                        key:`wgt-${wgtIdx}`,
                                        rcd:rcd,
                                        rcdId:rcd.__id,
                                        rcdIdx:rcdIdx,
                                        listType:"list",
                                        setRcdActive:fn=>{
                                            setActiveRcdId&&setActiveRcdId(rcd.__id);
                                            fn&&setTimeout(fn, 0);
                                        }
                                    });
                                }
                                return Wgt&&<Wgt
                                    key={`wgt-${wgtIdx}`}
                                    rcd={rcd}
                                    rcdId={rcd.__id}
                                    rcdIdx={rcdIdx}
                                    listType={"list"}
                                    setRcdActive={fn=>{
                                        setActiveRcdId&&setActiveRcdId(rcd.__id);
                                        fn&&setTimeout(fn, 0);
                                    }}
                                ></Wgt>
                            })}
                        </div>
                    </td>
                    {
                        listFlds.map((fldName, fldIdx)=>{
                            const val = String(rcd[fldName]===undefined?'':rcd[fldName]);
                            const MaxLen = 30;
                            return <td
                                key={Math.random()}
                                style={{wordWrap: "break-word"}}
                                // style={fldIdx<(listFlds.length-1)?{
                                //     width: 'auto',
                                //     "white-space": "nowrap",
                                //     // padding: "8px"
                                // }:{}}
                                title={val}
                            >
                                <div className="d-flex row">
                                    <div
                                        className="ww-rcdlist-label fw-bold"
                                    >{fldName}:</div>
                                    <div>
                                        {val.substring(0, Math.min(30, val.length))} {val.length>30&&'...'}
                                    </div>
                                </div>
                            </td>;
                        })
                    }
                </tr>;
            })}
        </tbody>
    </table>
}

export function useListOfOrdersOfStatus({
    status: orderStatus,

    resetPageFlag,
    page:pageIn,
    rcdsPerPage:rcdsPerPageIn, 

    filter:filterIn,
    orderby,

    hideIndex,
    hideID,
    hidePagination,
    hideSearch,
    hideListTypeSelector,
    hideListFldsSelector,

    btns,
    editDlg,

    listFlds:listFldsIn, 
    dataFlds,

    onItemClick,

    listType: listTypeIn,
    // [] customized CompList
    CompList,

    reset,

    opts
}){
    const tblName = 'orders';
    const [activeRcdId, setActiveRcdId] = useState(0);
    const [listType, setListType] = useState(listTypeIn||'list');
    const [page, setPage] = useState(pageIn||0);
    const [rcdsPerPage, setRcdsPerPage] = useState(rcdsPerPageIn||10);
    // const [filter, setFilter] = useState(filterIn||{});
    const [searchStr, setSearchStr] = useState('');
    const [searchCaretPosition, setSearchCaretPosition] = useState(0);
    // const [activeRcdId, setActiveRcdId] = useState(0);
    // const [listType, setListType] = useState(listTypeIn||'list');

    const {regUse, DefaultResponse, loading, errors} = regUses();
    const { data: tblDef } = regUse(useTblDef(tblName, 'tblDef'));
    // const listFlds = listFldsIn || (tblDef||{}).listFlds;
    const [listFlds, setListFlds] = useState(listFldsIn || (tblDef||{}).listFlds)
    const searchFlds = listFlds;
    // const filter = {...(filterIn||{__id:1})};
    const _filters = [{
        __filterFlds:(searchStr=>{
            const __filterFlds = {};
            'sn,date,buyer__xpd__,status,attachment'.split(',').forEach(fldName=>{
                __filterFlds[fldName] = searchStr
            });
            return __filterFlds;
        })(searchStr)
    }];
    const filters = [{
        // __filterFlds:(searchStr=>{
        //     const __filterFlds = {};
        //     'sn,date,buyer__xpd__,status,attachment'.split(',').forEach(fldName=>{
        //         __filterFlds[fldName] = searchStr
        //     });
        //     return __filterFlds;
        // })(searchStr)

        __commonFlds: 'sn,date,buyer__xpd__,status,attachment',
        __commonFilters: searchStr         

    }];
    const { data: rcdsGot, invalidate } = regUse(useOrdersOfStatus({
        type: orderStatus,
        opts: {
            page, 
            rcdsPerPage, 
            filters,
            orderby,
            // _orderby: tblDef?(listFlds=>{
            //     const fldNames = 'date,buyer__xpd__,sn,status,attachment'.split(',').filter(a=>a);
            //     return fldNames.map(fldName=>{
            //         return {
            //             fld: fldName,
            //             dir: 1
            //         };
            //     });
            // })(tblDef.listFlds || ''):[],
            expands: tblDef?(inputSettings=>{
                // const fldNames = Object.keys(inputSettings);
                // return fldNames.map(fldName=>{
                //     const inputSetting = inputSettings[fldName] || {};
                //     return inputSetting.type=="search"?{
                //         fld: fldName,
                //         tbl: inputSetting.srcTbl,
                //         tblFlds: inputSetting.srcSearchFlds
                //     }:false;
                // }).filter(a=>a)
                return [{
                    fld: 'buyer',
                    tbl: 'entities',
                    tblFlds: 'name'
                }];
            })(tblDef.inputSettings || {}):[]
        }
    }));

    const Component = ({})=><div>
        {!hideSearch&&<div className="row my-2">
            <SearchBar
                searchStr={searchStr}
                setSearchStr={setSearchStr}
                searchCaretPosition = {searchCaretPosition}
                setSearchCaretPosition = {setSearchCaretPosition}

                setPage={setPage}

                searchFlds={searchFlds}
            ></SearchBar>
        </div>}
        {!hideListTypeSelector&&<div className="row my-1">
            <SelectListType
                onSelect={listType=>setListType(listType)}
            ></SelectListType>
        </div>}
        {!hideListFldsSelector&&<div className="row my-1">
            <ListFldsSelector
                listFlds={listFlds}
                setListFlds={setListFlds}
                tblDef={tblDef}
                listFldsPool="date,sn,buyer__xpd__,status,note,attachement"
            ></ListFldsSelector>
        </div>}
        <DefaultResponse>
            <div role="form">

            <WWTabs
                tabDefs={[
                    {
                        caption: 'order list',
                        name:'orderList',
                        active: true,
                        Content: ({})=><DisplayRcdList
                            tblName = {tblName}

                            filters = {filters}

                            hideIndex = {hideIndex}
                            hideID = {hideID}
                            hidePagination = {hidePagination}
                            hideSearch = {hideSearch}
                            hideListTypeSelector = {hideListTypeSelector}

                            btns = {btns}
                            editDlg={editDlg}

                            listFlds = {listFlds}
                            dataFlds = {dataFlds}

                            onItemClick = {onItemClick}

                            // [] customized CompList
                            CompList = {CompList}

                            reset = {reset}

                            opts = {opts}

                            tblDef = {tblDef}
                            rcds = {rcdsGot}
                            invalidate = {invalidate}

                            activeRcdId = {activeRcdId}
                            setActiveRcdId = {setActiveRcdId}

                            listType = {listType}
                            setListType = {setListType}

                            page = {page}
                            setPage = {setPage}

                            rcdsPerPage = {rcdsPerPage}
                            setRcdsPerPage = {setRcdsPerPage}

                            searchStr = {searchStr}
                            setSearchStr = {setSearchStr}
                            
                            invalidateList={invalidate}
                        ></DisplayRcdList>
                    },
                    {
                        caption: 'error',
                        Content:({})=><div>
                            <h3>errors</h3>
                            {Object.keys((rcdsGot||{}).errors||{}).map(errType=>{
                                const errorsOfType = ((rcdsGot||{}).errors||{})[errType];
                                return <div
                                    key={errType}
                                >
                                    <h3>{errType}({errorsOfType.length})</h3>
                                    <p>{JSON.stringify(errorsOfType)}</p>
                                </div>;
                            })}
                            {/* <p>{JSON.stringify((rcdsGot||{}).errors)}</p> */}

                        </div>
                    }
                ]}
            ></WWTabs>            
            </div>


        </DefaultResponse>
    </div>;

    useEffect(_=>{
        setPage(0);
    }, [resetPageFlag])

    return {
        loading,
        error: errors,
        invalidate,
        setActiveRcdId,
        Component,
        setListType
    }

}

export function useRcdList({
    tblName, 

    resetPageFlag,
    page:pageIn,
    rcdsPerPage:rcdsPerPageIn, 

    filter:filterIn, 

    hideIndex,
    hideID,
    hidePagination,
    hideSearch,
    hideListTypeSelector,
    hideListFldsSelector,

    btns,
    editDlg,
    
    listFlds:listFldsIn, 
    dataFlds,

    searchFlds:searchFldsIn,

    onItemClick,

    listType: listTypeIn,
    // [] customized CompList
    CompList,

    reset,

    highLightFn,

    opts
}){

    const [activeRcdId, setActiveRcdId] = useState(0);
    const [listType, setListType] = useState(listTypeIn||'list');
    const [page, setPage] = useState(pageIn || 0);
    const [rcdsPerPage, setRcdsPerPage] = useState(rcdsPerPageIn||10);
    const [searchStr, setSearchStr] = useState('');
    const [searchCaretPosition, setSearchCaretPosition] = useState(0);

    // const [activeRcdId, setActiveRcdId] = useState(0);
    // const [listType, setListType] = useState(listTypeIn||'list');

    const {regUse, DefaultResponse, loading, errors} = regUses();

    const { data: tblDef } = regUse(useTblDef(tblName), 'tblDef');
    // const listFlds = listFldsIn || (tblDef||{}).listFlds || Object.keys((tblDef||{}).inputSettings || {}).join(',');
    
    const [listFlds, setListFlds] = useState(listFldsIn || (tblDef||{}).listFlds)

    const inputSettings = (tblDef||{}).inputSettings || {};
    const searchFlds = searchFldsIn || (tblDef||{}).listFlds || Object.keys((tblDef||{}).inputSettings || {}).join(',');
    const v1_filter = [
        {
            __filterFlds: ((tblDef, searchStr)=>{
                // if(!tblDef || !tblDef.listFlds || !searchStr)return false;

                const __filterFlds = {};
                // tblDef.listFlds.split(',').
                searchFlds.split(',').filter(a=>a).forEach(fldName=>{
                    __filterFlds[fldName] = searchStr;
                    if((inputSettings[fldName]||{}).type == 'search'){
                         __filterFlds[`${fldName}__xpd__`] = searchStr;
                    }
                })

                return __filterFlds;
            })(tblDef, searchStr)
        },
        {...(filterIn||{
            // __filtersRelation:'all',
            // __filterFlds: {__id:'^(1)$'}
        })}
    ].filter(a=>a.__filterFlds);

    const filter = [{
            ...(filterIn||{}),
            __commonFlds: listFlds,
            __commonFilters: searchStr
        }];
    
    const { data: rcdsGot, invalidate } = regUse(useRcds(
        tblName,
        page,
        listType=='tree'?9999:rcdsPerPage,
        filter,
        {
            reset: [getStringHash(searchStr), ...(reset?(reset.constructor===Array?reset:[reset]):[])],
            orderby: tblDef?(listFlds=>{
                const fldNames = listFlds.split(',').filter(a=>a);
                return fldNames.map(fldName=>{
                    return {
                        fld: fldName,
                        dir: 1
                    };
                });
            })(tblDef.listFlds || ''):[],
            expands: tblDef?(inputSettings=>{
                const fldNames = Object.keys(inputSettings);
                return fldNames.map(fldName=>{
                    const inputSetting = inputSettings[fldName] || {};
                    return inputSetting.type=="search"?{
                        fld: fldName,
                        tbl: inputSetting.srcTbl,
                        tblFlds: inputSetting.srcSearchFlds
                    }:false;
                }).filter(a=>a)
            })(tblDef.inputSettings || {}):[]
        }
    ));

    const Component = ({})=><div>
        {/* <div>{JSON.stringify(filter)}</div>
        <div>{searchStr}</div> */}
        {/* <div>{JSON.stringify(tblDef)}</div> */}
        {!hideSearch&&<SearchBar
            searchStr={searchStr}
            setSearchStr={setSearchStr}

            searchCaretPosition = {searchCaretPosition}
            setSearchCaretPosition = {setSearchCaretPosition}

            setPage={setPage}

            searchFlds={searchFlds}
        ></SearchBar>}
        {!hideListTypeSelector&&<div className="row">
            <SelectListType
                onSelect={listType=>setListType(listType)}
            ></SelectListType>
        </div>} 
        {!hideListFldsSelector&&<div className="row my-1">
            <ListFldsSelector
                listFlds={listFlds}
                setListFlds={setListFlds}
                tblDef={tblDef}
                // listFldsPool="date,sn,buyer__xpd__,status,note,attachement"
            ></ListFldsSelector>
        </div>}
        <DefaultResponse>
            <DisplayRcdList
                tblName = {tblName}

                // filter = {filter}
                searchFlds = {searchFlds}

                hideIndex = {hideIndex}
                hideID = {hideID}
                hidePagination = {hidePagination}
                hideSearch = {hideSearch}
                hideListTypeSelector = {hideListTypeSelector}

                btns = {btns}
                editDlg = {editDlg}
                listFlds = {listFlds} 
                dataFlds = {dataFlds}

                onItemClick = {onItemClick}

                // [] customized CompList
                CompList = {CompList}

                reset = {reset}

                opts = {opts}

                tblDef = {tblDef}
                rcds = {rcdsGot}
                invalidate = {invalidate}

                activeRcdId = {activeRcdId}
                setActiveRcdId = {setActiveRcdId}

                listType = {listType}
                setListType = {setListType}

                page = {page}
                setPage = {setPage}

                rcdsPerPage = {rcdsPerPage}
                setRcdsPerPage = {setRcdsPerPage}

                searchStr = {searchStr}
                setSearchStr = {setSearchStr}

                invalidateList={invalidate}
                highLightFn = {highLightFn}
            ></DisplayRcdList>
        </DefaultResponse>

    </div>
    
    useEffect(_=>{
        setPage(0);
    }, [resetPageFlag])

    return {
        loading,
        error: errors,
        invalidate,
        setActiveRcdId,
        Component,
        setListType
    }

}

export function ListFldsSelector({tblDef, listFldsPool, listFlds, setListFlds}){
    const inputSettings = ((tblDef||{}).inputSettings||{});
    const additionFldNames = [];
    const baseFldNames = ((listFldsPool&&listFldsPool.split(',')) || Object.keys(inputSettings) || []).map(fldName=>{
        if((inputSettings[fldName]||{}).type == 'search'){
            additionFldNames.push(`${fldName}__xpd__`);
        }
        return fldName;
    });
    const fldNames = [...baseFldNames, ...additionFldNames];
    
    // const additionFlds = [];
    // const baseListFlds = String(listFlds||'').split(',').filter(a=>a).map(listFld=>{
    //     if((inputSettings[listFld]||{}).type == 'search'){
    //         additionFlds.push(`${listFld}__xpd__`);
    //     }
    // });
    // const arrListFlds = [...baseListFlds, additionFlds];
    const arrListFlds = String(listFlds||'').split(',').filter(a=>a);
    
    return <div className="ww-list-flds-selector">
        {arrListFlds.map(fldName=><span
            key={fldName}
            value={fldName}
            className={` badge rounded-pill rounded-pill ${arrListFlds.indexOf(fldName)>=0?'bg-warning text-dark':'bg-primary'}`}
            onClick={evt=>{
                const clickedFldName = evt.target.getAttribute('value');
                const idxOfClickedFldName = arrListFlds.indexOf(clickedFldName);
                if( idxOfClickedFldName < 0 ){
                    arrListFlds.push(clickedFldName);
                }else{
                    arrListFlds.splice(idxOfClickedFldName, 1);
                }
                const newListFlds = arrListFlds.join(',')
                console.log('arrListFldsnewListFlds:', newListFlds);
                setListFlds(newListFlds);
            }}
        >{fldName}</span>)}
        <div>
            {fldNames.filter(fldNames=>arrListFlds.indexOf(fldNames)<0).map(fldName=><span
                key={fldName}
                value={fldName}
                className={` badge rounded-pill rounded-pill ${arrListFlds.indexOf(fldName)>=0?'bg-warning text-dark':'bg-primary'}`}
                onClick={evt=>{
                    const clickedFldName = evt.target.getAttribute('value');
                    const idxOfClickedFldName = arrListFlds.indexOf(clickedFldName);
                    if( idxOfClickedFldName < 0 ){
                        arrListFlds.push(clickedFldName);
                    }else{
                        arrListFlds.splice(idxOfClickedFldName, 1);
                    }
                    const newListFlds = arrListFlds.join(',')
                    console.log('arrListFldsnewListFlds:', newListFlds);
                    setListFlds(newListFlds);
                }}
            >{fldName}</span>)}
        </div>
    </div>;
}

export function SearchBar({searchStr, setSearchStr, setPage, searchFlds, searchCaretPosition, setSearchCaretPosition}){
    const refSearch = useRef();
    useEffect(_=>{
        if(refSearch.current){
            refSearch.current.focus();
        }
    });
    useEffect(_=>{
        if(refSearch.current){
            refSearch.current.selectionStart = refSearch.current.selectionEnd = searchCaretPosition;
        }
    }, [searchCaretPosition])

    
    return <div>
        <div className="input-group flex-nowrap mb-2" role="group" aria-label="Basic example"
            style={{"flex":"2"}}
        >
            <input className="form-control btn-outline-primary" type="search"
                placeholder={`Search ${searchFlds}`}
                aria-label="Search"
                ref={refSearch}
                defaultValue={searchStr}
                onChange={evt=>{
                    setSearchStr(evt.target.value);

                    setSearchCaretPosition(refSearch.current.selectionEnd);

                    setPage(0);
                }}
                onMouseDown={evt=>{
                    if(refSearch.current){
                        // setSearchCaretPosition(refSearch.current.selectionEnd);
                    }
                }}
            />
            <button className="btn btn-outline-warning" type="button"
                onClick={evt=>{
                    if(refSearch.current){
                        refSearch.current.value = '';
                        setSearchStr(refSearch.current.value);
                        setPage(0);
                    }

                }}
            >X</button>
            <button className="btn btn-outline-primary" type="button"
                onClick={evt=>{
                    if(refSearch.current){
                        setSearchStr(refSearch.current.value);
                        setPage(0);
                    }
                }}
            >Search</button>
        </div>
    </div>;
}

export function DisplayArray({rcds, listFlds:listFldsStr, listFldsInputSettings:listFldsInputSettingsIn, btns:btnsIn,
        onRcdSaved,activeRcdIdx:activeRcdIdxIn, highlightFn}){
    const [editIdx, setEditIdx] = useState(0);
    const [activeIdx, setActiveIdx] = useState(activeRcdIdxIn || 0);
    const listFlds = listFldsStr.split(',').filter(a=>a);
    const listFldsInputSettings = listFldsInputSettingsIn || {};
    const btns = btnsIn || [];
    const form = useForm();
    function EditRcdInline({fldName, value, form, inputSettings:inputSettingsIn}){
        const inputSettings = inputSettingsIn || {type: 'input'};
        const Wgt = getWidget(inputSettings.type);
        // const opts = optsIn || {};
        
        useLayoutEffect(_=>{
            form.setValue(fldName, value);
        });

        // return <div>{JSON.stringify(inputSettings)}</div>;
        return <Wgt
            fldName = {fldName}
            form = {form}
            fldDef = {inputSettings}
            opts = {inputSettings.opts || {}}
            // opts = {{
            //     curValues:{
            //         sn: 'test sn'

            //     },
            //     allowNew: true
            // }}
        ></Wgt>
        
        // <input type="text"
        //     defaultValue={value}
        // ></input>;
    }
    return <table
        className="table table-hover"
    >
        <thead>
            <tr>
                <th>No.</th>
                <th>action</th>
                {listFlds.map(fldName=><th
                    key={randomUUID()}
                >{fldName}</th>)}
            </tr>
        </thead>
        <tbody>
            {rcds.map((rcd, rcdIdx)=><tr
                id = {activeIdx}
                className={[rcdIdx==activeIdx?'border-warning':'', highlightFn&&highlightFn(rcd, rcdIdx)?'table-active':''].join(' ')}
                key={randomUUID()}
            >
                <td>{rcdIdx+1}</td>
                <td>
                {rcdIdx==editIdx?<button
                    className="btn btn-warning"
                    onClick={evt=>{
                        rcds[rcdIdx] = form.getValues();
                        onRcdSaved&&onRcdSaved(rcds[rcdIdx], rcdIdx);

                        setEditIdx(-1);
                        setActiveIdx(rcdIdx);
                    }}                    
                >save</button>:<button
                    className="btn btn-primary"
                    onClick={evt=>{
                        setEditIdx(rcdIdx);
                        setActiveIdx(rcdIdx);
                    }}
                >edit</button>}
                {btns.map(Btn=><Btn></Btn>)}
                </td>
                {listFlds.map(fldName=>{
                    const inputSettingsDef = listFldsInputSettings[fldName] || {};
                    const inputSettings = inputSettingsDef.constructor===Function?inputSettingsDef(rcd):inputSettingsDef;
                    return <td
                        key={randomUUID()}
                    >{rcdIdx==editIdx?<EditRcdInline
                        fldName={fldName}
                        value={rcd[fldName]}
                        form={form}
                        inputSettings={inputSettings}
                    ></EditRcdInline>:(inputSettings.getCaption?inputSettings.getCaption(rcd):rcd[fldName])}</td>;
                })}
            </tr>)}
        </tbody>
    </table>
}

export function DisplayRcdList({
    tblName, 
    page:pageIn,
    rcdsPerPage: rcdsPerPageIn, 

    filter:filterIn, 
    searchFlds,
    hideIndex,
    hideID,
    hidePagination,
    hideSearch,
    hideListTypeSelector,
    btns:btnsIn,
    editDlg,
    listFlds, 
    dataFlds,

    onItemClick,

    listType:listTypeIn,
    // [] customized CompList
    CompList,

    reset,

    opts,

    tblDef,
    rcds,
    invalidate,
    setActiveRcdId,
    activeRcdId,
    setListType,
    listType,

    page,
    setPage,

    searchStr,
    setSearchStr,

    invalidateList,
    highLightFn,
    
}){
    const refData = useRef({
        subCbs: {}
    });
    
    const {regUse, DefaultResponse} = regUses();
    const refSearch =useRef();

    const filterTmp = {}
    if(searchStr){
        (listFlds||'').split(',').filter(a=>a).forEach(fldName=>{
            filterTmp[fldName] = `.*${searchStr}.*`;
        });
    }

    const filter = {...filterTmp, ...(filterIn||{})};

    const {
        rcdsPerPage,
        setRcdsPerPage,
        rcdCount,
        setRcdCount,
        Pagination
    } = usePagination(page, rcdsPerPageIn, setPage);

    // let component;
    const CompListType = CompList || CompListTypes[listType];

    const Component = ({})=>{
        const refData = useRef({
            inited: false
        })
        const compRef = useRef(null);
        const hdl = evt=>{
            const __id = evt.target.getAttribute('__id');
            if(__id){
                onItemClick&&onItemClick({tblName, rcdId:__id, evt, rcd: rcds.rcdsById[__id]});
                setActiveRcdId(__id);
            }
        };
        useLayoutEffect(() => {
            if(refData.current.inited)return;
            refData.current.inited = true;
            if(compRef.current){
                compRef.current.querySelectorAll('[__id]').forEach(rcdComp=>{
                    const __id = rcdComp.getAttribute('__id');
                    const rcd = rcds.rcds.find(rcd=>rcd.__id == __id);
                });

                compRef.current.removeEventListener('click', hdl);
                compRef.current.addEventListener('click', hdl);
            }
        }, []);

        const standardBtns = {
                stdEdit: ({rcdId, setRcdActive})=><button type="button"
                    className="btn btn-sm btn-primary"
                    onClick={evt=>{
                        if(!editDlg)return;
                        const {setTblName, setRcdId, openDialog} = editDlg;

                        // evt.stopPropagation();
                        setTblName(tblName);
                        // [] for RcdEditDialog
                        setRcdId(rcdId);
                        // [] for list
                        setRcdActive&&setRcdActive();
                        openDialog();
                    }}
                >edit</button>,
                stdAddChild: ({rcdId, setRcdActive, listType})=>(listType=="Tree")&&<button type="button"
                    className="btn btn-sm btn-primary"
                    onClick={evt=>{
                        if(!editDlg)return;
                        const {setTblName, setRcdId, openDialog, getRcdDefault, setRcdDefault} = editDlg;
                        
                        setTblName(tblName);
                        // [] for RcdEditDialog
                        // getNewRcdId()
                        setRcdId(false);
                        setRcdDefault({...getRcdDefault(), __pid:rcdId})

                        // [] for list
                        setRcdActive&&setRcdActive();
                        openDialog();
                    }}
                >add child</button>,
                stdDelete: ({rcdId, setRcdActive})=><button type="button"
                    className="btn btn-sm btn-warning"
                    onClick={evt=>{
                        if(!editDlg)return;
                        const {setTblName, setRcdId, openDialog} = editDlg;
                        
                        setTblName(tblName);
                        // [] for RcdEditDialog
                        setRcdId(rcdId);
                        setTimeout(_=>{
                            if(window.confirm('sure to delete?')){
                                delTblRcds(tblName, rcdId).then(r=>{
                                    invalidateList();
                                })
                            }
                            setRcdActive&&setRcdActive();
                        }, 10)
                        setRcdActive&&setRcdActive();

                    }}
                >delete</button>
        };

        const btns = (Object.values(btnsIn||{})).filter(a=>a).map(btnDef=>{
            if(btnDef.constructor == String){
                return standardBtns[btnDef];
            }else{
                return btnDef;
            }
        });

        return <div ref={compRef} className="my-2">
            <DefaultResponse>
                <div>
                        {(listType!='tree')&&!hidePagination&&<Pagination
                            rcdCount={rcds.rcdCnt}
                        ></Pagination>}

                        <CompListType
                            tblDef={tblDef}
                            rcds={rcds}
                            listFlds={listFlds}
                            dataFlds={dataFlds || '__id'}

                            activeRcdId={activeRcdId}
                            setActiveRcdId={setActiveRcdId}

                            subCbs={refData.current.subCbs}

                            hideIndex={hideIndex}
                            hideID={hideID}

                            highLightFn={highLightFn}

                            opts={{
                                btns,
                                page,
                                rcdsPerPage,
                                listFlds,
                                // onItemClick, [] moved to parent
                                ...(opts||{})
                            }}
                        ></CompListType>
                </div>
            </DefaultResponse>
        </div>

    };

    return <Component></Component>;
}

